<template>
    <v-dialog v-model="show" persistent max-width="600px">
        <v-card>
            <v-card-text>
                {{ data }}
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="gray" @click="close()">
                    بستن
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import {mapActions} from 'vuex';
    export default {
        name: 'messagePopup',
        props: ['data'],
        data() {
            return {
                show: true,
            };
        },
        watch: {
            show(val){
                this.dialogIsShown(val);
            },
        },
        methods: {
            ...mapActions('popup', ['dialogIsShown']),
            close() {
                this.$emit('close');
            }
        },

    };
</script>